<template>
	<div id="app">
		<!-- router-view 默认插槽，解构出 Component 和 route -->
		<router-view v-slot="{ Component, route }">
			<!-- 判断：如果当前路由带 noLayout，就直接显示页面本身 -->
			<!-- 否则外面包一层 LayoutWrapper，并把页面作为子组件传进去 -->
			<component :is="route.meta.noLayout ? Component : LayoutWrapper">
				<component :is="Component" />
			</component>
		</router-view>
	</div>
</template>

<script>
	import LayoutWrapper from "@/layout/index.vue";

	export default {
		components: {
			LayoutWrapper
		}
	};
</script>

<style>
	#app {
		width: 100vw;
		height: 100vh;
		background-color: #020308;
		overflow: hidden;
	}
</style>
